<template>
  <div id="home" class="text-center">
    <img src="../assets/Apop_Logo_lg.png" alt="Apoplectic logo">
    <p class="font-weight-bold">Welcome to Apoplectic! Please sign in or
      <b-button variant="outline-danger" @click="$router.push('signup')">Request Access</b-button>
    </p>
    <Login/>
  </div>
</template>

<script>
  import Login from '../components/Login.vue'

  export default {
    name: 'home',
    components: {
      Login
    }
  }
</script>
